export default __webpack_public_path__ + "static/media/Rectangle 28.3d38b040.png";